import {
  Component,
  OnInit,
  HostBinding,
  ViewChild,
  ElementRef,
  NgZone,
  AfterViewInit,
  ComponentFactoryResolver, Injector, Output, EventEmitter, TemplateRef, ChangeDetectorRef, Optional, Inject, LOCALE_ID
} from '@angular/core';
import { SysFarrisLookupComponent } from '@gsp-sys/sysmgr-ui';
import { ProcessDesignerUIState } from '../../../../app/process-designer.uistate';
import { ExprEditMode, ExpressionService, InjectedType } from '@gsp-svc/expression';
import { PositionPerformerEntity } from '../../entities/position-performer.entity';
import {GspPositionFilter, SysLookupDetailComponent, TreeFilter} from '@gsp-sys/sysmgr-lookup';
import {BsModalService} from '@farris/ui-modal';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../../i18n/assets/lang.resource';
import { PositionsNamePipe } from './positions-name.pipe';

@Component({
  selector: 'app-position-performer',
  templateUrl: './position-performer.component.html',
  styleUrls: ['./position-performer.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class PositionPerformerComponent implements OnInit, AfterViewInit {
  @HostBinding('class')
  cls = 'd-flex flex-fill h-100';

  @Output() closeEmitter = new EventEmitter<any>();
  @Output() submitEmitter = new EventEmitter<any>();
  @ViewChild(SysFarrisLookupComponent) posiHelp: SysFarrisLookupComponent;
  @ViewChild('buttonRef') buttonRef: TemplateRef<any>;

  @ViewChild('inputGroup') inputGroup: ElementRef;
  showClearButton = false;
  isRequired = false;
  groupIcon = '<i class="f-icon f-icon-lookup"></i>';

  positionTypes = [
    { value: '0', text: this.localePipe.transform('component.positionPerformer.orgPosition') },
    { value: '1', text: this.localePipe.transform('component.positionPerformer.generalPosition') }
  ];
  performerName = '';
  style: any = { background: '#FFF' };

  condition: string;

  newFilter: GspPositionFilter = {};
  treeFilter: TreeFilter = {};
  curPosIdList: any[] = [];
  editState = true;
  showCondition = true;
  positionType: string;
  position: PositionPerformerEntity;
  positions: PositionPerformerEntity[] = [];
  constructor(
    public designerUIState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private ngZone: NgZone,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private modalService: BsModalService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
    private positionsNamePipe: PositionsNamePipe
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
    this.position = this.position || new PositionPerformerEntity();
    this.performerName = this.performerName || (this.positions && this.positions.length ? this.positionsNamePipe.transform(this.positions) : this.position.performerName || '');
    if (this.designerUIState.scene === 'inSuite') {
      this.position.positionType = '1';
      this.newFilter = { positionType: '1' };
      this.style = { background: '#FFF', height: '150px' };
    }
  }

  ngOnInit() {
    this.designerUIState.getOrgConfig().subscribe(re => {
      if (re && re.currentValue === 'true') {
        this.isRequired = true;
      }
    });
  }

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.inputGroup.nativeElement.addEventListener(
        'mouseenter',
        this.onMouseEnter.bind(this)
      );
      this.inputGroup.nativeElement.addEventListener(
        'mouseleave',
        this.onMouseLeave.bind(this)
      );
    });
  }

  onMouseEnter(event) {
    this.showClearButton = true;
    if (this.showClearButton) {
      this.toggleClearIcon(event, true);
    }
  }
  onMouseLeave(event) {
    this.showClearButton = false;
    this.toggleClearIcon(event, false);
  }
  private toggleClearIcon(event: any, isShow = false) {
    const str = isShow ? '' : 'none';
    const clearIcon = event.target.querySelector('.input-group-clear');
    if (clearIcon) {
      clearIcon.style.display = str;
    }
  }

  clickOK() {
    this.submitEmitter.emit(this.position);
  }

  clickCancel() {
    this.closeEmitter.emit();
  }

  clear() {
    this.position.performerId = null;
    this.position.performerName = null;
    this.performerName = '';
  }

  positionTypeChange(data) {
    if (data.value === '0') {
      this.newFilter = { positionType: '0' };
      this.positionType = '0';
    } else {
      this.newFilter = { positionType: '1' };
      this.positionType = '1';
    }
    this.clear();
    this.position.orgType = null;
    this.position.orgId = null;
  }

  selectOrganition() {
    // this.expr.clearContext();
    if (this.position.positionType === '1') {
      if (this.designerUIState.schemas.length > 0) {
        for (const schema of this.designerUIState.schemas) {
          this.expr.addSchema('Schema', schema);
        }
        if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
          const entityType = this.designerUIState.schemas[0].entityTypes[0];
          this.expr.addInjectedEntity(entityType.name, 'Schema',
            entityType.name, InjectedType.EntityType);
        }
      }
      const context = new Array();
      if (this.designerUIState.subActivityContext.length > 0) {
        for (const variable of this.designerUIState.subActivityContext) {
          if (!context.some(c => c.key === variable.key)) {
            context.push(variable);
          }
        }
      }
      if (context.length > 0) {
        for (const v of context) {
          this.expr.addContext(v);
        }
      }
      this.expr.setEditPattern(ExprEditMode.Advanced);
      this.expr.addExpressionText(this.position.orgId);
      this.expr.buildExpression().then((expr: string) => {
        this.position.orgId = expr;
        //点击确定后，去除表达式里面的新增的上下文变量
        if(context.length > 0) {
          this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
        }
      });
    }
  }
  selectPosition() {
    this.setPosition();
  }
  editCondition() {
    // this.expr.clearContext();
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    let context = new Array();
    context = this.designerUIState.addContext(context);
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.activityComponentContext.length > 0) {
      for (const variable of this.designerUIState.activityComponentContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.setEditPattern(ExprEditMode.Conditional); // 表达式展现模式：默认简易版
    this.expr.addExpressionText(this.position.condition);
    this.expr.buildExpression().then((expressioninfo: string) => {
      this.position.condition = expressioninfo;
      for (const p of this.positions) {
        p.condition = expressioninfo;
      }
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  orgTypeChange(re: any) {
    this.position.orgType = re.data.value;
  }
  clearOrgType() {
    this.position.orgType = null;
  }
  positionsSelected(data) {
    this.positions = [];
    if (data || data.data.length > 0) {
      const positions = [];
      for(const dataSelected of data.data) {
        if (this.editState) {
          this.position =new PositionPerformerEntity();
          this.position.performerId = dataSelected.id;
          this.position.performerCode = dataSelected.code;
          this.position.performerName = dataSelected.name;
          this.position.type = 'wf.PositionParticipantExpression';
          if (!this.position.positionType) {
            this.position.positionType = dataSelected.posType + '';
            this.newFilter = {
              positionType: dataSelected.posType
            };
          }
          this.position.isRequired = this.isRequired;
          this.position.condition = this.condition ? this.condition:"";
          positions.push(this.position);
        } else {
          this.position.performerId = dataSelected.id;
          this.position.performerCode = dataSelected.code;
          this.position.performerName = dataSelected.name;
          this.position.type = 'wf.PositionParticipantExpression';
          if (!this.position.positionType) {
            this.position.positionType = dataSelected.posType + '';
            this.newFilter = {
              positionType: dataSelected.posType
            };
          }
          this.position.isRequired = this.isRequired;
          this.position.condition = this.condition ? this.condition:"";
          positions.push(this.position);
        }
      }
      this.positions = [...positions];
      this.performerName = this.positions&&this.positions.length?(this.positionsNamePipe.transform(this.positions)):(this.position.performerName?this.position.performerName:'')
    }
  }
  setPosition() {
    this.positions = [];
    const compFactory = this.resolver.resolveComponentFactory(SysLookupDetailComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.initGridIdList = this.curPosIdList ;
    compRef.instance.treeFilter = this.treeFilter;
    compRef.instance.listFilter = this.newFilter;
    compRef.instance.sourceType = 'position';
    compRef.instance.multiSelect = false;
    // 编辑状态下只能单选
    if(this.positionType === "0" && this.editState) {      
      compRef.instance.multiSelect = true;
    }
    const modalConfig = {
      title: this.localePipe.transform('component.positionPerformer.sysPositions'),
      width: 1000,
      height: 550,
      showButtons: true,
      buttons: compRef.instance.btnTemplateRef,
      showMaxButton: true,
      resizable: false
    };
    const dialog = this.modalService.show(compRef, modalConfig);
    // 取消后
    compRef.instance.afterCancle.subscribe(res => {
      // 消失模态框
      dialog.close();
    });
    // 确认后
    compRef.instance.afterConfirm.subscribe(res => {
      this.positionsSelected(res);
    });
  }

  getPerformers() {
    if(!this.editState) {
      this.positions.push(this.position)
    }
    return this.positions;
  }

}
